import {useContext} from 'react'
import {UserSettingsContext} from './UserSettingsContext'

export const useUserSettings = () => {
  const contextInstance = useContext(UserSettingsContext)
  if (!contextInstance) throw new Error('Cannot call useUserSettings() outside of <UserSettingsProvider>')
  return contextInstance
}
